import { css } from 'linaria';
import { styled } from 'linaria/react';

export const SectionVlimitWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 880px;
  margin: 0;
`;

export const vSection = css`
  overflow-y: hidden;
`;
